// This file is generated by a script. Do not edit this file directly.
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Button", "../Input", "../Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Button"), require("../Input"), require("../Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Button, global.Input, global.Icon);
    global.Search = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Button, _Input, _Icon) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Search = Search;
  _react = _interopRequireWildcard(_react);
  function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
  function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  function Search(_ref) {
    var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      onSearch = _ref.onSearch;
    var inputRef = (0, _react.useRef)(null);
    var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      query = _useState2[0],
      setQuery = _useState2[1];
    var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isInitial = _useState4[0],
      setIsInitial = _useState4[1];
    var _useState5 = (0, _react.useState)('closed'),
      _useState6 = _slicedToArray(_useState5, 2),
      interactiveStatus = _useState6[0],
      setInteractiveStatus = _useState6[1];
    var buttonStatus = {
      closed: 'cop-pointer-events-auto',
      open: 'open cop-pointer-events-none cop-opacity-0'
    }[interactiveStatus];
    var inputStatus = {
      closed: 'cop-pointer-events-none cop-scale-x-0',
      open: 'open cop-pointer-events-auto cop-scale-x-100 cop-origin-left'
    }[interactiveStatus];
    var inputOrigin = {
      left: 'cop-origin-left',
      right: 'cop-origin-right'
    }[align];
    var alignment = {
      left: 'cop-left-0',
      right: 'cop-right-0'
    }[align];
    (0, _react.useEffect)(function () {
      var timeout = setTimeout(function () {
        onSearch(query);
      }, 300);
      return function () {
        return clearTimeout(timeout);
      };
    }, [query, onSearch]);
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "cop-flex-end cop-relative cop-h-7 cop-flex-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(buttonStatus, " ").concat(alignment, " cop-absolute cop-top-0")
    }, /*#__PURE__*/_react["default"].createElement(_Button.SecondaryButton, {
      label: "Search",
      onClick: function onClick() {
        var _inputRef$current;
        setInteractiveStatus('open');
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
      },
      prefixIcon: "Search"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(inputStatus, " ").concat(inputOrigin, " cop-relative cop-h-full cop-transition")
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      className: "cop-absolute cop-left-0 cop-top-0 cop-z-10 cop-h-3 cop-w-3 cop-px-3 cop-py-2",
      icon: "Search"
    }), /*#__PURE__*/_react["default"].createElement(_Input.Input, {
      className: ['cop-border-px', 'cop-h-full', 'cop-border-gray-100', 'cop-pl-8', 'cop-outline-0', 'cop-transition', 'focus-within:cop-border-black', 'focus-visible:cop-outline-0', 'focus-visible:cop-ring-0'].join(' '),
      containerClassName: [alignment, 'cop-absolute', 'cop-top-0', 'cop-h-full', 'cop-border-px', 'cop-w-full'].join(' '),
      onBlur: function onBlur() {
        var _inputRef$current2;
        if ((inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.value) === '') {
          setInteractiveStatus('closed');
          setIsInitial(true);
        }
      },
      onChange: function onChange(e) {
        if (isInitial) {
          setIsInitial(false);
        }
        setQuery(e.target.value);
      },
      ref: inputRef,
      value: query
    }), /*#__PURE__*/_react["default"].createElement("button", {
      className: ['cop-absolute', 'cop-right-0', 'cop-top-0', 'cop-z-10', 'cop-appearance-none', 'cop-border-0', 'cop-bg-transparent', 'cop-px-3', 'cop-py-2', 'cop-outline-0'].join(' '),
      onClick: function onClick() {
        setInteractiveStatus('closed');
        setIsInitial(true);
        setQuery('');
      }
    }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      className: "cop-h-3 cop-w-3",
      icon: "Cross"
    })))));
  }
});
